import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { Button, Modal, Table, Form } from 'react-bootstrap'

import { toast } from 'react-toastify'

import moment from 'moment'

import { SERVER_ } from  '../../config';

import Dialog from '../../services/Dialogs'

import './moda_info.scss'


const ModalInformeTramite = ( props ) => {

    const dialog = new Dialog();

    const formatDate = (date) => moment(date).format('DD[-]MMMM[-]YYYY').toUpperCase();

    const getAge = (dateString) => {
      var today = new Date();
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }

	const { uuid_tramite, showModalInforme, onHideModalInforme } = props
	
	const [ ficha_data, setFichaData ] = useState<any>({
		folio : "",
		idusuario : {
			nombres : '',
			paterno : '',
			materno : '',
			email : '',
			celular : '',
		},
		idgerente : {
			nombres : '',
			paterno : '',
			materno : '',
			email : '',
			celular : '',
		},
		idestatus : {
			id : 0,
			estatus : ""
		},
		idciudadano: {
		    uuid : "",
		    curp : "",
		    rfc : "",
		    fecha_nacimiento : "",
		    nombres : "",
		    paterno : "",
		    materno : "",
		    sexo : "",
		    seguro_social : "",
		    direccion : "",
		    colonia : "",
		    cp : "",
		    telefono : "",
		    celular : "",
		    email : ""
		  },
		  idsucursal : {
		  	nombre_sucursal : ""
		  },
		  historial_estatus : [],
		  depto_estrategias : {				
				semanas_cotizadas : "",
				fecha_aseguramiento: "",
				idafore : {
					afore : ""
				},
				monto_rcv: 0,
				monto_aseguramiento: 0,
				monto_aseguramiento_final: 0,
				fecha_baja_anterior: "",
				fecha_alta_anterior: "",
				fecha_baja_nuevo: "",
				fecha_alta_nuevo: "",
		  },
		  aseguramiento_evidencia : {
		  	uuid : ""
		  }
	})

	const cargarData = async () => {
		try{
			let res = await RequestService.getEndPoint('tramite/ficha_tecnica/'+uuid_tramite)
			if(res.data){
				setFichaData(res.data)
			}
		}
		catch(e){
			toast.error('Error al cargar la información del trámite')
		}
	}

  React.useEffect(() => {
    cargarData()
  }, []);



  const cancelarTramite = async (e:any)  => {

        await dialog.open({
          accept: 'Si',
          dialogClass: '',
          message: 'CANCELAR TRÁMITE',
          target: e.target,
          template: `<p><small>Este proceso no podrá deshacerse</small></p>
          `
        })
        let dialogo : any = await dialog.waitForUser()
        
        if(dialogo){


            try{

              let res = await RequestService.update('tramite/cancelar/'+uuid_tramite, {})
              if(res.data){    
              	cargarData()
                toast.warning('Este trámite se marco como cancelado')
              }
              else{
                toast.error('Tuvimos problemas al cancelar el trámite')    
              }

            }
            catch(e){
              toast.error('Tuvimos problemas al cancelar el trámite')
            }


        }

  }







	return (

		<React.Fragment>
			

				      <Modal backdrop="static" size="lg" dialogClassName="modal-90w" show={showModalInforme} onHide={onHideModalInforme}>
				        <Modal.Header closeButton>
				          <Modal.Title>Ficha del Trámite</Modal.Title>
				        </Modal.Header>
				        <Modal.Body>


									        	<h4 className="titulares">Información de los Responsables</h4>

									        	<div className="row">
									        		<div className="col-sm-6">
									        			{
									        				// JSON.stringify(ficha_data.idusuario)
									        			}

														<dl>
														    <dt>Asesor</dt>
														    <dd><small><b>{ficha_data.idusuario.nombres}</b> {ficha_data.idusuario.paterno} {ficha_data.idusuario.materno}</small></dd>
														    <dt>Celular</dt>
														    <dd><small>{ficha_data.idusuario.celular}</small></dd>
														    <dt>Correo Electrónico</dt>
														    <dd><small>{ficha_data.idusuario.email}</small></dd>
														</dl>

									        		</div>
									        		<div className="col-sm-6">
									        			{
									        				// JSON.stringify(ficha_data.idgerente)
									        				ficha_data.idgerente && (

																	<dl>
																	    <dt>Gerente</dt>
																	    <dd><small><b>{ficha_data.idgerente.nombres}</b> {ficha_data.idgerente.paterno} {ficha_data.idgerente.materno}</small></dd>
																	    <dt>Celular</dt>
																	    <dd><small>{ficha_data.idgerente.celular}</small></dd>
																	    <dt>Correo Electrónico</dt>
																	    <dd><small>{ficha_data.idgerente.email}</small></dd>
																	</dl>
																	
									        					)
									        			}




									        		</div>
									        	</div>


                                                <h4 className="titulares">Solicitante</h4>

                                                <h5>Información Personal</h5>


                                                <div className="row">
                                                  <div className="col-sm-4">
                                                      <b><small>Nombre</small></b>
                                                      <p>{ficha_data.idciudadano.nombres}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Apellido Paterno</small></b>
                                                      <p>{ficha_data.idciudadano.paterno}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Apellido Materno</small></b>
                                                      <p>{ficha_data.idciudadano.materno}</p>
                                                  </div>
                                                </div>


                                                <div className="row">
                                                  <div className="col-sm-3">
                                                      <b><small>Fecha de Nacimiento</small></b>
                                                      <p>{formatDate(ficha_data.idciudadano.fecha_nacimiento)}</p>
                                                  </div>
                                                  <div className="col-sm-2">
                                                      <b><small>Edad</small></b>
                                                      <p>{getAge(ficha_data.idciudadano.fecha_nacimiento)} AÑOS</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Sexo</small></b>
                                                      <p>{ficha_data.idciudadano.sexo=='H'?'HOMBRE':'MUJER'}</p>
                                                  </div>
                                                </div>


                                                <div className="row">
                                                  <div className="col-sm-4">
                                                      <b><small>CURP</small></b>
                                                      <p>{ficha_data.idciudadano.curp}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>RFC</small></b>
                                                      <p>{ficha_data.idciudadano.rfc}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>NSS</small></b>
                                                      <p>{ficha_data.idciudadano.seguro_social}</p>
                                                  </div>
                                                </div>


                                                <hr className="border border-primary border-1 opacity-75" />

                                                <h5>Información de Contacto</h5>


                                                <div className="row">
                                                  <div className="col-sm-3">
                                                      <b><small>Teléfono</small></b>
                                                      <p>{ficha_data.idciudadano.telefono||'No Proporcionado'}</p>
                                                  </div>
                                                  <div className="col-sm-3">
                                                      <b><small>Celular</small></b>
                                                      <p>{ficha_data.idciudadano.celular||'No Proporcionado'}</p>
                                                  </div>
                                                  <div className="col-sm-6">
                                                      <b><small>Correo Electrónico</small></b>
                                                      <p>{ficha_data.idciudadano.email}</p>
                                                  </div>
                                                </div>

                                                <div className="row">
                                                  <div className="col-sm-6">
                                                      <b><small>Dirección</small></b>
                                                      <p>{ficha_data.idciudadano.direccion||'No Proporcionado'}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Colonia</small></b>
                                                      <p>{ficha_data.idciudadano.colonia||'No Proporcionado'}</p>
                                                  </div>
                                                  <div className="col-sm-2">
                                                      <b><small>C.P.</small></b>
                                                      <p>{ficha_data.idciudadano.cp}</p>
                                                  </div>
                                                </div>


                                                <h4 className="titulares">Trámite</h4>




									        	<div className="row">
									        		<div className="col-sm-6">
									        			<p className="">FOLIO <b>{ficha_data.folio}</b></p>
									        		</div>
									        		<div className="col-sm-6">
									        			<p className="text-right">{uuid_tramite}</p>
									        		</div>
									        	</div>

									        	


                                                



                                                <div className="row">
                                                  <div className="col-sm-4">
                                                      <b><small>Fecha del Trámite</small></b>
                                                      <p>{formatDate(ficha_data.fecha_tramite)}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Sucursal</small></b>
                                                      <p>{ficha_data.idsucursal.nombre_sucursal}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Estatus</small></b>
                                                      <p><span className={'badge estatus_'+ficha_data.idestatus.id }> {ficha_data.idestatus.estatus}</span></p>
                                                  </div>
                                                </div>

                                                


                                                <div className="row">
                                                  <div className="col-sm-4">
                                                      <b><small>Monto de Retiro (Captura)</small></b>
                                                      <p>$ {(ficha_data.depto_estrategias.monto_aseguramiento).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>Monto RCV</small></b>
                                                      <p>$ {(ficha_data.depto_estrategias.monto_rcv).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</p>
                                                  </div>
                                                  <div className="col-sm-4">
                                                      <b><small>AFORE</small></b>
                                                      <p>{ficha_data.depto_estrategias?.idafore?.afore||'SIN AFORE'}</p>
                                                  </div>
                                                </div>





                                                {
                                                	[5,6,9,4,7].indexOf(ficha_data.idestatus.id) > -1 && (

                                                		<React.Fragment>



				                                                <div className="row">
				                                                  <div className="col-sm-4">
				                                                      <b><small>Fecha de Alta Anterior</small></b>
				                                                      <p>{formatDate(ficha_data.depto_estrategias.fecha_alta_anterior)}</p>
				                                                  </div>
				                                                  <div className="col-sm-4">
				                                                      <b><small>Fecha de Baja Anterior</small></b>
				                                                      <p>{formatDate(ficha_data.depto_estrategias.fecha_baja_anterior)}</p>
				                                                  </div>
				                                                </div>


				                                                <div className="row">
				                                                  <div className="col-sm-4">
				                                                      <b><small>Semanas Cotizadas</small></b>
				                                                      <p>{ficha_data.depto_estrategias.semanas_cotizadas}</p>
				                                                  </div>
				                                                  <div className="col-sm-4">
				                                                      <b><small>Fecha de Aseguramiento</small></b>
				                                                      {
				                                                      	ficha_data.depto_estrategias.fecha_aseguramiento && (
				                                                      		<p>{formatDate(ficha_data.depto_estrategias.fecha_aseguramiento)}</p>
				                                                      	)
				                                                      }
				                                                      
				                                                  </div>
				                                                  <div className="col-sm-4">
				                                                      <b><small>Monto Aseguramiento</small></b>
				                                                      {
				                                                      	ficha_data.depto_estrategias.monto_aseguramiento_final && (
				                                                      		<p>$ {(ficha_data.depto_estrategias.monto_aseguramiento_final)}</p>
				                                                      	)
				                                                      }
				                                                  </div>
				                                                </div>


				                                                <div className="row">
				                                                  <div className="col-sm-4">
				                                                      <b><small>Fecha de Alta Aseguramiento</small></b>
				                                                      <p>{formatDate(ficha_data.depto_estrategias.fecha_alta_nuevo)}</p>
				                                                  </div>
				                                                  <div className="col-sm-4">
				                                                      <b><small>Fecha de Baja Aseguramiento</small></b>
				                                                      {
				                                                      	ficha_data.depto_estrategias.fecha_baja_nuevo && (
				                                                      		<p>{formatDate(ficha_data.depto_estrategias.fecha_baja_nuevo)}</p>
				                                                      	)
				                                                      }
				                                                      
				                                                  </div>
				                                                  <div className="col-sm-4">
				                                                      <b><small>Constancia Aseguramiento</small></b>
				                                                      {
				                                                      	[5,6,9,7].indexOf(ficha_data.idestatus.id) > -1 && (
				                                                      		<>
				                                                      			{
				                                                      				ficha_data.aseguramiento_evidencia && (
				                                                      						<p><a target="_blank" href={SERVER_+'aseguramiento_evidencia/'+ficha_data.aseguramiento_evidencia.uuid}>clic para ver </a></p>
				                                                      					)
				                                                      			}
				                                                      		
				                                                      		</>
				                                                      	)
				                                                      }

				                                                      {
				                                                      	// JSON.stringify(ficha_data.aseguramiento_evidencia)
				                                                      }
				                                                  </div>
				                                                </div>


                                                		</React.Fragment>

                                                	)
                                                }






                                                {
                                                	// JSON.stringify(ficha_data.historial_estatus)
                                                }

												<table className="table">
												  <thead>
												    <tr>
												      <th scope="col">Estatus</th>
												      <th scope="col">Fecha</th>
												      <th scope="col">Usuario</th>
												    </tr>
												  </thead>
												  <tbody>
												  	{
												  		ficha_data.historial_estatus.map( (fecha:any) =>

																    <tr key={ Math.random().toString(36).substr(2, 9) }>
																      <td width={200}>
																      	<span className={'badge estatus_'+fecha.idestatus.id }> {fecha.idestatus.estatus}</span>
																      </td>
																      <td width={200}>
																      	<small>{fecha.fecha_creacion}</small>
																      </td>
																      <td>
																      	<small><b>{fecha.idusuario.nombres}</b> {fecha.idusuario.paterno} {fecha.idusuario.materno}</small>
																      </td>
																    </tr>

												  		)
												  	}

												  </tbody>
												</table>



												{
													[2,3,4].indexOf(ficha_data.idestatus.id) > -1 && (
														<React.Fragment>		
															<div className="d-grid gap-2 mt-4 mb-4">
															  <button onClick={(event)=>{cancelarTramite(event)}} className="btn btn-link btn-sm" type="button">Cancelar el Trámite <i className="fa fa-trash-o" /></button>
															</div>
														</React.Fragment>
													)
												}






				        	

				        </Modal.Body>
				      </Modal>


		</React.Fragment>

	)

}

export default ModalInformeTramite